import React from "react";
import "./PageNotFound.css";

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <div className="code">404</div>
      <h1 className="message">Oops ! Page not found.</h1>
    </div>
  );
};

export default PageNotFound;
